export default function getWeblabTreatment(weblabName) {
    const metaEl = document.head.querySelector('meta[name="a2z:mons_weblab_treatment"]');
    if (!metaEl || !metaEl.content) {
        return null;
    }
    for (const weblabNameTreatment of metaEl.content.split(',')) {
        const [thisWeblabName, treatment] = weblabNameTreatment.split('=', 2);
        if (thisWeblabName === weblabName) {
            return treatment;
        }
    }
    return null;
}
